import React, { useState, useEffect } from 'react'
import Question from  "../../../../partials/Questions/Question"
import Button from  "../../../../partials/Button"
import "./Questions.scss"
import FeedbackBlock from '../../../../partials/FeedbackBlock'
import ButtonsHolder from '../../../../partials/Button/ButtonsHolder'

const Questions = (props) => {
    const { data, feedback, next, onComplete } = props
    
    const [currentQuestion, setCurrentQuestion] = useState();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [answerState, setAnswerState] = useState(false)
    const [completed, setCompleted] = useState(false);
    const [completedQuestions, setCompletedQuestions] = useState([])

    useEffect(() => {
      if(currentIndex > -1 && currentIndex < data.length) {
        setCurrentQuestion(data[currentIndex])
      }
    }, [currentIndex, currentQuestion])

    useEffect(()=>{

      if(next) {
        onContinueHandle()
      }
      
    }, [next])

    const setFeedbackState = (answer, show) => {
        setAnswerState(answer)
    }

    const onSelectOptionHandle = (answerSelected) => {

        setAnswerState({
            ...currentQuestion,
            status: answerSelected.status,
            correct: answerSelected.correct,
            answers: answerSelected.answers
        })
    }

    const onContinueHandle = () => {
        
        setCurrentQuestion()
        handleCompleted(answerState)
        if(currentIndex + 1 >= data.length) {
            setCompleted(true)
        } else {
            setCurrentIndex( currentIndex + 1 );
        }
        setFeedbackState(false, false)
      
    }

    const handleCompleted = (completed) => {
        const add = completedQuestions
        add.push(completed)
        setCompletedQuestions(add)
    }

    const onRetryHandle = () => {
        setAnswerState()
        setCurrentQuestion()
    }

    const onCompleteHandle = () => {
        onComplete(completedQuestions)
    }

    const feedbackOverlay = (feedback) => {

        if(feedback){
            return <div className="feedback-overlay">
                
                {feedback.answers.map((answer,index) => {
                    return (<p key={index}>
                        {answer.feedback}
                    </p>)
                })}

                {feedback?.correct ?
                    <Button className={'small primary'} onClick={onContinueHandle} text="Next" />
                    :
                    <Button className={'small primary'} onClick={onRetryHandle} text="Retry" />
                }
        
            </div>
        }
        else{
            return false;
        }
    }

    return (
        <div className="questions-container">

            <div className="questions-column">
                { currentQuestion &&
                    <>

                    <Question 
                        data={currentQuestion}
                        feedback={onSelectOptionHandle}
                        showContinue={true}
                    />
                    
                    </>
                }
            </div>
            <div className="questions-feedback-column">
                <FeedbackBlock 
                    variant={'none'}
                    status={answerState?.status}
                    caption={answerState?.correct ? 'This could work' : 'failed'}
                    overlay={feedbackOverlay(answerState)}
                    
                >   
                    <div className="image-wrapper">
                        <img src="media/img/full-length-test-photo.png" alt="caption" />
                    </div>
                </FeedbackBlock>
                <ButtonsHolder orientation="right">
                    <Button 
                        text="continue" 
                        disabled={completed ? false : true} 
                        onClick={onCompleteHandle}
                    />
                </ButtonsHolder>
            </div>
        </div>
    )

}

export default Questions